import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Signup() {
  const [form, setForm] = useState({ full_name: '', email: '', password: '', confirm_password: '', phone: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  function set(field, value) { setForm(f => ({ ...f, [field]: value })) }

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (!form.full_name.trim()) { setError('Full name is required'); return }
    if (form.password !== form.confirm_password) { setError('Passwords do not match'); return }
    if (form.password.length < 6) { setError('Password must be at least 6 characters'); return }
    setLoading(true)

    // If no email provided, generate a placeholder so Supabase Auth is happy
    const emailToUse = form.email.trim()
      ? form.email.trim()
      : `${form.full_name.trim().toLowerCase().replace(/\s+/g, '.')}.${Date.now()}@tlcunlimited.app`

    const { error } = await supabase.auth.signUp({
      email: emailToUse,
      password: form.password,
      options: {
        data: { full_name: form.full_name, phone: form.phone },
        emailRedirectTo: 'https://www.fieldcanopy.com'
      }
    })

    if (error) { setError(error.message); setLoading(false); return }
    setSuccess(true)
    setLoading(false)
  }

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successIcon}>✅</div>
          <h2 style={styles.successTitle}>Account Created!</h2>
          {form.email.trim() ? (
            <p style={styles.successText}>Check your email at <strong>{form.email}</strong> and click the confirmation link to activate your account.</p>
          ) : (
            <p style={styles.successText}>Your account has been created. You can now sign in with your name and password.</p>
          )}
          <Link to="/login" style={styles.loginLink}>Go to Sign In</Link>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}>🌿</div>
          <h1 style={styles.logoText}>TLC Unlimited</h1>
          <p style={styles.logoSub}>Create Your Account</p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.field}>
            <label style={styles.label}>Full Name *</label>
            <input style={styles.input} type="text" value={form.full_name} onChange={e => set('full_name', e.target.value)} placeholder="John Smith" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Email <span style={styles.optional}>(optional)</span></label>
            <input style={styles.input} type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@example.com" />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Phone</label>
            <input style={styles.input} type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="(915) 555-0000" />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password *</label>
            <input style={styles.input} type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Min 6 characters" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Confirm Password *</label>
            <input style={styles.input} type="password" value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)} placeholder="Repeat password" required />
          </div>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
          <p style={styles.loginText}>Already have an account? <Link to="/login" style={styles.loginLinkInline}>Sign In</Link></p>
        </form>
      </div>
    </div>
  )
}

const styles = {
  container: { minHeight: '100vh', background: 'linear-gradient(135deg, #1a2e1a 0%, #2d4a2d 50%, #1a3320 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: "'DM Sans', sans-serif" },
  card: { background: 'rgba(255,255,255,0.97)', borderRadius: '16px', padding: '48px 40px', width: '100%', maxWidth: '420px', boxShadow: '0 25px 60px rgba(0,0,0,0.4)' },
  logo: { textAlign: 'center', marginBottom: '32px' },
  logoIcon: { fontSize: '40px', marginBottom: '8px' },
  logoText: { margin: 0, fontSize: '26px', fontWeight: '700', color: '#1a2e1a' },
  logoSub: { margin: '4px 0 0', color: '#6b7c6b', fontSize: '14px', letterSpacing: '1px', textTransform: 'uppercase' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#374151', letterSpacing: '0.5px', textTransform: 'uppercase' },
  optional: { fontWeight: '400', color: '#9ca3af', textTransform: 'none', letterSpacing: '0', fontSize: '11px' },
  input: { padding: '11px 14px', borderRadius: '8px', border: '1.5px solid #d1d5db', fontSize: '15px', fontFamily: 'inherit' },
  button: { padding: '14px', background: '#2d4a2d', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginTop: '4px' },
  error: { background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '12px', borderRadius: '8px', fontSize: '14px' },
  loginText: { textAlign: 'center', fontSize: '14px', color: '#6b7c6b', margin: '4px 0 0' },
  loginLinkInline: { color: '#2d4a2d', fontWeight: '600' },
  successIcon: { fontSize: '48px', textAlign: 'center', marginBottom: '16px' },
  successTitle: { textAlign: 'center', fontSize: '22px', fontWeight: '700', color: '#1a2e1a', margin: '0 0 12px' },
  successText: { textAlign: 'center', fontSize: '15px', color: '#374151', lineHeight: '1.6', margin: '0 0 24px' },
  loginLink: { display: 'block', textAlign: 'center', background: '#2d4a2d', color: 'white', padding: '12px', borderRadius: '8px', textDecoration: 'none', fontWeight: '600' }
}
